import { render, staticRenderFns } from "./WhiteboardColorPickerModal.vue?vue&type=template&id=55a5c569&scoped=true&"
import script from "./WhiteboardColorPickerModal.vue?vue&type=script&lang=js&"
export * from "./WhiteboardColorPickerModal.vue?vue&type=script&lang=js&"
import style0 from "./WhiteboardColorPickerModal.vue?vue&type=style&index=0&id=55a5c569&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a5c569",
  null
  
)

export default component.exports